import {
    createResourceMap,
    registerFlatI18nResources,
    type RegisterResourcesOptions,
} from 'scbk-services';

/**
 * features 다국어 resource 등록.
 *
 * feature package 규칙:
 * - createInstance() 금지
 * - initReactI18next 금지
 * - i18n.init() 금지
 * - changeLanguage() 금지
 * - scbk-services의 registerFlatI18nResources만 사용
 */
export const registerResources = ({ market }: RegisterResourcesOptions): void => {
  const modules = import.meta.glob('./resources/**/**/*.json', {
    eager: true,
  }) as Record<string, { default: Record<string, string> }>;

  const resourceMap = createResourceMap(modules);

  registerFlatI18nResources({
    resources: resourceMap[market],
    ns: 'translation',
    overwrite: true,
  });
};
